import { Model } from '@nozbe/watermelondb'
import { field, json } from '@nozbe/watermelondb/decorators'


const sanitizeData = rawData => rawData
export class ProductModel extends Model {

  static table = 'product'

  @field('productId')
  productId: string

  @field('active')
  active: boolean

  @field('commercialization')
  commercialization: boolean

  @field('continuous')
  continuous: boolean

  @field('cultivate')
  cultivate: boolean

  @field('digitalization')
  digitalization: boolean

  @field('minReceiptDate')
  minReceiptDate: string

  @field('nfe')
  nfe: boolean

  @field('productGroupId')
  productGroupId: string

  @field('purchasing')
  purchasing: boolean

  @field('scheduled')
  scheduled: boolean

  @field('shortDescription')
  shortDescription: string

  @field('slug')
  slug: string

  @json('barcodes', sanitizeData)
  barcodes

  @json('ean', sanitizeData)
  ean

  @json('extraAttributes', sanitizeData)
  extraAttributes

  @field('createdAt')
  createdAt: string

  @field('updatedAt')
  updatedAt: string

}
